import { Component } from '@angular/core';

@Component({
  selector: 'global-alerts-configurations',
  templateUrl: './global-alerts-configuration.component.html',
  styleUrls: ['./global-alerts-configuration.component.scss']
})
export class GlobalAlertsConfigurationComponent { }
